// MCP Security — Attack-class chip row.
//
// Takes an array of attack-class slugs (phase-A injection families or
// scanner categories) and renders a tight row of monospaced pills.
// Compact by default — the Events table uses this inside a 1fr cell.

import React from "react";
import { Box, Tooltip } from "@mui/material";
import tokens from "./tokens";

export const ATTACK_CLASS_LABEL = {
  model_template: "model_template",
  override_english: "override_eng",
  override_multiling: "override_i18n",
  stego_unicode: "stego",
  role_transition: "role_transition",
  literal_sig: "literal_sig",
  injection_other: "injection",
  credential: "credential",
  exfil: "exfil",
  taint: "taint",
  anomaly: "anomaly",
  schema: "schema",
  resource_uri: "resource_uri",
  agent: "agent",
};

/**
 * Props:
 *   classes: string[]   (attack-class slugs)
 *   limit?:  number     (default 4; extra collapses to +N tooltip)
 *   dense?:  bool       (smaller font / padding for table rows)
 */
export default function AttackChips({ classes = [], limit = 4, dense = false, sx }) {
  if (!classes || classes.length === 0) {
    return (
      <Box component="span" sx={{ color: tokens.neutral[600], fontSize: dense ? 11 : 12 }}>
        —
      </Box>
    );
  }
  const visible = classes.slice(0, limit);
  const extra = classes.length - visible.length;
  const chip = (c) => (
    <span
      key={c}
      style={{
        display: "inline-block",
        fontFamily: tokens.fontMono,
        fontSize: dense ? 10 : 11,
        padding: dense ? "1px 7px" : "2px 9px",
        borderRadius: 999,
        background: tokens.neutral[100],
        color: tokens.neutral[800],
        whiteSpace: "nowrap",
      }}
    >
      {ATTACK_CLASS_LABEL[c] || c}
    </span>
  );
  return (
    <Box sx={{ display: "flex", gap: 0.5, flexWrap: dense ? "nowrap" : "wrap", overflow: "hidden", ...sx }}>
      {visible.map(chip)}
      {extra > 0 && (
        <Tooltip title={classes.slice(limit).join(", ")}>
          <span
            style={{
              display: "inline-block",
              fontFamily: tokens.fontMono,
              fontSize: dense ? 10 : 11,
              padding: dense ? "1px 7px" : "2px 9px",
              borderRadius: 999,
              background: tokens.neutral[200],
              color: tokens.neutral[800],
            }}
          >
            +{extra}
          </span>
        </Tooltip>
      )}
    </Box>
  );
}
